"use strict";
'use es6'; // Properties here should be immutable and never change when fetched via upgrade catalog
// If there is a property that might change (e.g. currency), it should be fetched via that endpoint

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var Features = _interopRequireWildcard(require("self-service-api/constants/_MerchandiseFeatures"));

var BillingNameKeys = _interopRequireWildcard(require("self-service-api/constants/BillingNameKeys"));

var _HighlightedMerchBizObjectives = _interopRequireDefault(require("self-service-api/constants/HighlightedMerchBizObjectives"));

var _ObjectDefaults = require("self-service-api/constants/ObjectDefaults");

var _MerchandiseMap;

var MerchandiseMap = (_MerchandiseMap = {}, (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_CRM, {
  parcels: [{
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  features: Features._crmFeatureIds,
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_FREE, {
  parcels: [{
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  features: Features._marketingFreeFeatureIds,
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER, {
  parcels: [{
    parcelName: 'marketing-starter-2016',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-starter',
    parcelVersion: 1
  }],
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, {
  parcels: [{
    parcelName: 'marketing-starter-2018',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-starter',
    parcelVersion: 2
  }],
  billingNameKey: BillingNameKeys.MARKETING_STARTER,
  features: Features._marketingStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS, {
  parcels: [{
    parcelName: 'additional-contacts-and-emails-5x',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019, {
  billingNameKey: BillingNameKeys.MARKETING_STARTER,
  features: Features._marketingStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019],
  parcels: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_MC, {
  billingNameKey: BillingNameKeys.MARKETING_STARTER_MC,
  features: Features._marketingStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_STARTER_MC],
  parcels: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS_NOV_2019, {
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  parcels: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS_MC, {
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  parcels: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_BASIC, {
  parcels: [{
    parcelName: 'marketing-basic-2011',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-basic-2012',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-basic-2013',
    parcelVersion: 1
  }],
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_BASIC_CONTACTS, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, {
  parcels: [{
    parcelName: 'marketing-pro-2011',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-pro-2012',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-pro-2013',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-pro',
    parcelVersion: 6
  }],
  billingNameKey: BillingNameKeys.MARKETING_PROFESSIONAL,
  features: Features._marketingProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_MC, {
  parcels: [],
  billingNameKey: BillingNameKeys.MARKETING_PROFESSIONAL_MC,
  features: Features._marketingProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_MC]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS, {
  parcels: [],
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS_MC, {
  parcels: [],
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE, {
  parcels: [{
    parcelName: 'marketing-ent-2011',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-ent-2012',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-ent-2013',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-enterprise',
    parcelVersion: 6
  }],
  billingNameKey: BillingNameKeys.MARKETING_ENTERPRISE,
  features: Features._marketingEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_MC, {
  parcels: [],
  billingNameKey: BillingNameKeys.MARKETING_ENTERPRISE_MC,
  features: Features._marketingEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_MC]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_CONTACTS, {
  parcels: [],
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_CONTACTS_MC, {
  parcels: [],
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_FREE, {
  parcels: [{
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  features: Features._salesFreeFeatureIds,
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PRO_LEGACY, {
  parcels: [{
    parcelName: 'sales-pro',
    parcelVersion: 1
  }],
  activelySold: false,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER, {
  parcels: [{
    parcelName: 'sales-pro',
    parcelVersion: 1
  }],
  activelySold: false,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_STARTER, {
  parcels: [{
    parcelName: 'sales-starter',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.SALES_STARTER,
  features: Features._salesStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_STARTER]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020, {
  parcels: [],
  billingNameKey: BillingNameKeys.SALES_STARTER,
  features: Features._salesStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_STARTER_ADDL_USER_MAR_2020, {
  parcels: [],
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, {
  // Sales Pro users are grandfathered into Sales Professional.
  parcels: [{
    parcelName: 'sales-pro-bundle',
    parcelVersion: 1
  }, {
    parcelName: 'sales-pro',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.SALES_PROFESSIONAL,
  features: Features._salesProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_PROFESSIONAL]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER, {
  parcels: [{
    parcelName: 'sales-pro-additional-seat',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019, {
  // Legacy parcels bc original Sales Pro and 2017 Sales Professional are grandfathered into this SKU
  parcels: [{
    parcelName: 'sales-pro-bundle',
    parcelVersion: 1
  }, {
    parcelName: 'sales-pro',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.SALES_PROFESSIONAL,
  features: Features._salesProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019, {
  parcels: [],
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_ENTERPRISE, {
  parcels: [{
    parcelName: 'sales-enterprise-bundle',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.SALES_ENTERPRISE,
  features: Features._salesEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_ENTERPRISE]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER, {
  parcels: [{
    parcelName: 'sales-enterprise-additional-seat',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_FREE, {
  parcels: [{
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  features: Features._serviceFreeFeatureIds,
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_STARTER, {
  parcels: [{
    parcelName: 'service-starter',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.SERVICE_STARTER,
  features: Features._serviceStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SERVICE_STARTER]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020, {
  parcels: [],
  billingNameKey: BillingNameKeys.SERVICE_STARTER,
  features: Features._serviceStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_STARTER_ADDL_USER_MAR_2020, {
  parcels: [],
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, {
  parcels: [{
    parcelName: 'service-professional-bundle',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.SERVICE_PROFESSIONAL,
  features: Features._serviceProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER, {
  parcels: [{
    parcelName: 'service-professional-additional-seat',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE, {
  parcels: [{
    parcelName: 'service-enterprise-bundle',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.SERVICE_ENTERPRISE,
  features: Features._serviceEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER, {
  parcels: [{
    parcelName: 'service-enterprise-additional-seat',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SERVICE_ENTERPRISE_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_CMS_PROFESSIONAL, {
  parcels: [{
    parcelName: 'cms-standalone-paid',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.CMS_PROFESSIONAL,
  features: Features._cmsProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_CMS_PROFESSIONAL]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_CMS_ENTERPRISE, {
  parcels: [{
    parcelName: 'cms-enterprise',
    parcelVersion: 1
  }],
  billingNameKey: BillingNameKeys.CMS_ENTERPRISE,
  features: Features._cmsEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_CMS_ENTERPRISE]
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_API, {
  parcels: [{
    parcelName: 'api-addon-2016',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_API
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_ADS, {
  parcels: [{
    parcelName: 'ads',
    parcelVersion: 1
  }, {
    parcelName: 'ads-grandfathered',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_ADS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_ADS_CAPACITY, {
  parcels: [{
    parcelName: 'ads-add-on',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_DEDICATED_IP, {
  parcels: [{
    parcelName: 'dedicated-ip',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_DEDICATED_IP
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_REPORTING, {
  parcels: [{
    parcelName: 'reporting',
    parcelVersion: 1
  }, {
    parcelName: 'reporting-grandfathered',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_REPORTING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, {
  parcels: [{
    parcelName: 'transactional-email',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_TRANSACTIONAL_EMAIL
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_CUSTOM_SSL, {
  parcels: [{
    parcelName: 'content-custom-ssl',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_CUSTOM_SSL
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_WEBSITE_STARTER, {
  parcels: [{
    parcelName: 'sites',
    parcelVersion: 1
  }, {
    parcelName: 'sites-basic-2014',
    parcelVersion: 1
  }, {
    parcelName: 'sites-grandfathered',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  activelySold: false
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_WEBSITE_UNLIMITED, {
  parcels: [{
    parcelName: 'sites-unlimited',
    parcelVersion: 1
  }, {
    parcelName: 'sites-unlimited-2014',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_BRAND_DOMAIN, {
  parcels: [{
    parcelName: 'additional-brand-domains',
    parcelVersion: 1
  }],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_BRAND_DOMAIN
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_WORKFLOWS, {
  parcels: [],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_WORKFLOWS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_LISTS, {
  parcels: [],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_LISTS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_FIRST_TEMPLATE_SETUP, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_MARKETING_FUNDAMENTALS, {
  parcels: [],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_TRAINING_MARKETING_FUNDAMENTALS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_CRM_MANAGEMENT, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CONSULTING_AGENCY_PIPELINE, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CONSULTING_SALES_SKILLS, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_MARKETING_BASIC_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_MARKETING_PROFESSIONAL_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_MARKETING_ENTERPRISE_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CRM_SALES_STARTER_KIT, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SALES_ENTERPRISE_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONE_DAY, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_FOUR_HOUR, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TECH_CONSULTING_ONE_DAY, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TECH_CONSULTING_FOUR_HOURS, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_DESIGNATED_TECHNICAL_SUPPORT, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_PROFESSIONAL_SUITE_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_ENTERPRISE_SUITE_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING, {
  parcels: [],
  billingNameKey: BillingNameKeys.HSFS_SETUP,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TECHNICAL_CONSULTING_ONGOING, {
  parcels: [],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_TECHNICAL_CONSULTING_ONGOING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_MONTHLY, {
  parcels: [],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_INBOUND_CONSULTING_MONTHLY
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONGOING, {
  parcels: [],
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_INBOUND_CONSULTING_ONGOING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_PREMIUM_CONSULTING, {
  parcels: [],
  billingNameKey: BillingNameKeys.SERVICE_PREMIUM_CONSULTING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_FIRST_TIME_FULL_MIGRATION, {
  parcels: [],
  features: {},
  bizObjectives: [],
  billingNameKey: null
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_LATAM_MARKETING_PROFESSIONAL_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_LATAM_MARKETING_ENTERPRISE_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SERVICE_STARTER_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SALES_STARTER_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_MARKETING_STARTER_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TEMPLATE_SETUP, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CMS_PROFESSIONAL_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CMS_ENTERPRISE_ONBOARDING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.LIMIT_INCREASE_REPORTING, {
  parcels: [],
  features: {},
  bizObjectives: []
}), _MerchandiseMap);
var exportedMerchandiseMap = {}; // Add defaults. Defaults overridden by hubMap
// if specified

Object.keys(MerchandiseMap).forEach(function (key) {
  exportedMerchandiseMap[key] = Object.assign({}, _ObjectDefaults.MerchandiseObjectDefault, {}, MerchandiseMap[key]);
});
var _default = exportedMerchandiseMap;
exports.default = _default;
module.exports = exports.default;